import {Box} from "@mui/material";
import {LChart, LChartSeries, LineChart} from "../../../components/chart/line_chart";
import React, {useState} from "react";
import {ManagerStats} from "arteco-api-client-ts";
import {colors} from "../../../components/utils/colors";
import {FilterChips, Panel} from "../../../components/kit";

export interface EmpProductivityChartProps {
	stats: ManagerStats;
}

export const EmpProductivityChart = ({stats}: EmpProductivityChartProps) => {
	const [accumulated, setAccumulated] = useState<boolean>(true);

	const lineChart = (stats: ManagerStats): LChart => {
		const xAxisData: string[] = [];
		let i = 0;
		const seriesData: LChartSeries[] = [
			{label: "Totales", color: colors[i++ % colors.length], values: []},
			{label: "Time & Materials", color: colors[i++ % colors.length], values: []},
			{label: "Asignada a Presupuesto", color: colors[i++ % colors.length], values: []},
			{label: "Sin Asignar", color: colors[i++ % colors.length], values: []}
		];

		let prevWorked = 0;
		let prevBudget = 0;
		let prevTm = 0;
		let prevSin = 0;

		stats.months?.map((x) => {
			xAxisData.push(x.year + "-" + x.month);
			if (accumulated) {
				prevWorked += x.dedication?.workedHours || 0;
				prevBudget += x.dedication?.budgetHours || 0;
				prevTm += x.dedication?.tmHours || 0;
				prevSin += x.dedication?.unassignedHours || 0;
				seriesData[0].values.push(prevWorked);
				seriesData[1].values.push(prevTm);
				seriesData[2].values.push(prevBudget);
				seriesData[3].values.push(prevSin);
			} else {
				seriesData[0].values.push(x.dedication?.workedHours || 0);
				seriesData[1].values.push(x.dedication?.tmHours || 0);
				seriesData[2].values.push(x.dedication?.budgetHours || 0);
				seriesData[3].values.push(x.dedication?.unassignedHours || 0);
			}
		});

		return {
			xAxisData,
			seriesData
		}
	}



	return (
		<Panel title="Horas dedicadas del equipo"
			   subtitle="Hasta el último mes cerrado, de las dedicaciones del cierre con el presupuesto ya corregido. El mes en curso no entra hasta que se cierra."
			   action={<FilterChips value={accumulated} onChange={setAccumulated} options={[
				   {value: true, label: "Acumulado"}, {value: false, label: "Mensual"},
			   ]}/>}>
			<Box sx={{minWidth: 0}}><LineChart data={lineChart(stats)} height={{xs: 300, md: 360}}/></Box>
		</Panel>
	)
}
